import styled from "styled-components";
import {Flex} from "./flex";

export const FlexCol = styled(Flex)`
    flex-direction: column;
`;
